import type { RouteLocationNormalizedLoaded } from "vue-router"
import { useRoute } from "vue-router"
import { currentUser } from "./auth"

import Gleap from "gleap"
import { posthog } from "posthog-js"
import { dittofeed } from "./dittofeed"

declare global {
    interface Window {
        posthog: any
    }
}

let route: RouteLocationNormalizedLoaded | undefined

export default function trackEvent(name: string, customData?: Record<string, any>) {
    const baseData: Record<string, any> = {}

    // `useRoute` is based on injections, so we have to "cache" its value here
    if (!route) {
        route = useRoute()
    }

    if (route?.params.campaign) {
        baseData["Campaign ID"] = route.params.campaign
    }
    if (route?.query.video) {
        baseData["Video ID"] = route.query.video
    }

    const data = { ...baseData, ...customData }

    try {
        window.analytics?.track(name, data)
    } catch (error) {
        console.warn(
            "An error occured while trying to submit an analytics event to Segment:",
            error,
        )
    }

    const user = currentUser.value
    if (user) {
        try {
            // Use window.posthog if it has proper config, otherwise use imported posthog
            const activePosthog = window.posthog?.config?.token ? window.posthog : posthog
            activePosthog.capture(name, {
                distinct_id: user.sub,
                ...data,
            })
        } catch (error) {
            console.warn(
                "An error occured while trying to submit an analytics event to PostHog:",
                error,
            )
        }

        dittofeed.track(name, data)
    }

    try {
        Gleap.trackEvent(name, data)
    } catch (error) {
        console.warn("An error occured while trying to submit an event to Gleap:", error)
    }

    // check iubenda consent before sending events to pixels
    const { purposes = {} } = window._iub?.cs?.api?.getPreferences() ?? {}

    if (window.fbq && purposes?.["5"]) {
        try {
            window.fbq("trackCustom", name, data)
        } catch (error) {
            console.warn(
                "An error occured while trying to submit an event to Facebook Pixel:",
                error,
            )
        }
    }

    if (window.gtag && purposes?.["5"]) {
        try {
            window.gtag("event", name, data)
        } catch (error) {
            console.warn("An error occured while trying to submit an event to gtag:", error)
        }
    }
}
